module.exports = __webpack_public_path__ + "img/user.427af7d1.png";